import { useStaticQuery, graphql } from 'gatsby';

// Live stats (subscriber count, GitHub stars, latest version) baked into the
// static query at build time. Storybook aliases this module to a mock so the
// numbers stay fixed and Chromatic doesn't diff on every build.
export function useDXData() {
  const { dxData } = useStaticQuery(graphql`
    query DXQuery {
      dxData {
        subscriberCount
        githubStars
        latestVersion
      }
    }
  `);

  return dxData;
}
